import {
  Seniority,
  LegalLocationType,
  LegalLocation,
  EmploymentType,
  Stream,
} from '../../../types';

export const getSeniorities = (stream?: Stream) => {
  if (!stream) return [];
  if (
    [
      Stream.DESIGNER,
      Stream.SOLUTION_ARCHITECT,
      Stream.DESIGNER,
      Stream.DQ_ANALYST,
      Stream.COPYWRITER,
    ].includes(stream)
  ) {
    return [
      Seniority.JUNIOR,
      Seniority.MIDDLE,
      Seniority.SENIOR,
      Seniority.LEAD,
    ];
  } else if ([Stream.PM].includes(stream)) {
    return [Seniority.MIDDLE, Seniority.SENIOR, Seniority.LEAD, Seniority.DM];
  } else if ([Stream.DEVELOPER].includes(stream)) {
    return [
      Seniority.JUNIOR_1,
      Seniority.JUNIOR_2,
      Seniority.MIDDLE_1,
      Seniority.MIDDLE_2,
      Seniority.SENIOR_1,
      Seniority.SENIOR_2,
      Seniority.TECH_LEAD,
    ];
  } else {
    return [
      Seniority.JUNIOR_1,
      Seniority.JUNIOR_2,
      Seniority.MIDDLE_1,
      Seniority.MIDDLE_2,
      Seniority.SENIOR_1,
      Seniority.SENIOR_2,
      Seniority.LEAD,
    ];
  }
};

export const streams = Object.values(Stream);

export const legalLocations: LegalLocationType[] = [
  {
    id: 'ARGENTINA',
    country: LegalLocation.ARGENTINA,
    countryCode: 'AR',
  },
  {
    id: 'BRAZIL',
    country: LegalLocation.BRAZIL,
    countryCode: 'BR',
  },
  {
    id: 'COLOMBIA',
    country: LegalLocation.COLOMBIA,
    countryCode: 'CO',
  },
  {
    id: 'GUATEMALA',
    country: LegalLocation.GUATEMALA,
    countryCode: 'GT',
  },
  {
    id: 'INDIA',
    country: LegalLocation.INDIA,
    countryCode: 'IN',
  },
  {
    id: 'MEXICO_CONTRACTOR',
    country: LegalLocation.MEXICO,
    employmentType: EmploymentType.CONTRACTOR,
    countryCode: 'MX · C',
  },
  {
    id: 'MEXICO_EMPLOYEE',
    country: LegalLocation.MEXICO,
    employmentType: EmploymentType.EMPLOYEE,
    countryCode: 'MX · E',
  },
  {
    id: 'POLAND',
    country: LegalLocation.POLAND,
    countryCode: 'PL',
  },
  {
    id: 'PORTUGAL',
    country: LegalLocation.PORTUGAL,
    countryCode: 'PT',
  },
  {
    id: 'REMOTE',
    country: LegalLocation.REMOTE,
    countryCode: 'REM',
  },
  {
    id: 'UKRAINE',
    country: LegalLocation.UKRAINE,
    countryCode: 'UA',
  },
  {
    id: 'UNITED_STATES_CONTRACTOR',
    country: LegalLocation.UNITED_STATES,
    employmentType: EmploymentType.CONTRACTOR,
    countryCode: 'US · C',
  },
  {
    id: 'UNITED_STATES_EMPLOYEE',
    country: LegalLocation.UNITED_STATES,
    employmentType: EmploymentType.EMPLOYEE,
    countryCode: 'US · E',
  },
];
